import emailjs from 'emailjs-com';

export const sendEmail = (e) => {
  e.preventDefault();

  // Replace with your Service ID, Template ID, and User ID
  emailjs
    .sendForm('service_sq0xkr4', 'template_6ghkdge', e.target, '3jhPm1D3a0scYX3A_')
    .then(
      (result) => {
        document.querySelectorAll("input")[0].value = "";
        document.querySelectorAll("textarea")[0].value = "";
        alert('Your message was sent successfully');
      },
      (error) => {
        alert('Failed to send your message');
      }
    );
};
